<template>
    <PageLayout>
        <template #navigation>
            <Navigation />
        </template>

        <template #banner>
            <Banner />
        </template>

        <template #blocks>
            <Blocks />
        </template>

        <template #popup>
            <Popup />
        </template>

        <template #pre-footer>
            <PreFooter />
        </template>

        <template #footer>
            <Footer />
        </template>
    </PageLayout>
</template>

<script setup>
    import PageLayout from '~/components/layouts/PageLayout'

    import Navigation from '~/components/navigation/Navigation'
    import Banner from '~/components/banner/Banner'
    import Popup from '~/components/popup/Popup'
    import PreFooter from '~/components/pre-footer/PreFooter'
    import Footer from '~/components/footer/Footer'

    import Blocks from '~/components/blocks/Blocks'

    provide('page-type', 'home')

</script>

<style lang="scss" scoped>

</style>
